import { useState } from "react";
import EditProfileForm from "../../../components/forms/edit-profile/edit-profile-form.component";
import EditMatchingPreferences from "../../../components/forms/edit-profile/edit-matching-preferences.component";

const EditProfileScreen = () => {
    const [activeTab, setActiveTab] = useState("general");

    return (
        <div className="max-w-4xl">
            <h2 className="mb-6 hidden md:block header-font text-[18px] font-normal">Edit Profile</h2>
            
            <div className="flex border-b border-gray-200 mb-8 gap-8">
                <button 
                    onClick={() => setActiveTab("general")}
                    className={`pb-3 text-sm font-medium transition-colors ${
                        activeTab === "general" 
                            ? "text-primary border-b-2 border-primary" 
                            : "text-gray-500 hover:text-gray-700"
                    }`}
                >
                    General & Payment Info
                </button>
                <button 
                    onClick={() => setActiveTab("matching")}
                    className={`pb-3 text-sm font-medium transition-colors ${
                        activeTab === "matching" 
                            ? "text-primary border-b-2 border-primary" 
                            : "text-gray-500 hover:text-gray-700"
                    }`}
                >
                    Ruumie Preferences
                </button>
            </div>

            <div className="animate-fade-in">
                {activeTab === "general" && <EditProfileForm />}
                {activeTab === "matching" && <EditMatchingPreferences />}
            </div>
        </div>
    );
}

export default EditProfileScreen;